import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Button } from 'components/Base';
import { Field } from 'redux-form';
import Fields from 'components/Fields';
import Icons from 'components/Icons';

const useStyles = makeStyles({
  edit: {
    textAlign: 'right',
    cursor: 'pointer'
  },
  modal: {
    padding: '1rem'
  },
  fieldRow: {
    width: '500px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    alignContent: 'center',
    paddingLeft: '1rem',
    paddingRight: '1rem'
  },
  fieldRowRev: {
    width: '500px',
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start',
    alignItems: 'center',
    alignContent: 'center',
    paddingLeft: '1rem',
    paddingRight: '1.5rem',
    marginTop: '1rem'
  },
  fieldCellLeft: {
    width: '100%',
    paddingRight: '1rem',
    marginTop: '1.5rem'
  },
  fieldCellRight: {
    width: '100%',
    marginTop: '1.5rem'
  },
  icon: {
    height: '100%',
    width: '30px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center'
  }
});

interface CustomerProps {
  fields: any;
  newCustomer: boolean;
  setNewCustomer: Function;
}

const Customer = ({ fields, newCustomer, setNewCustomer }: CustomerProps) => {
  const classes = useStyles();

  const addNewCustomer = () => {
    setNewCustomer(!newCustomer);
    fields.push({
      id: 0,
      first_name: '',
      last_name: '',
      is_jointed: false,
      display_name: ''
    });
  };

  const removeNewCustomer = () => {
    fields.splice(1, 1);
    setNewCustomer(false);
  };
  return (
    <div style={{ width: '100%' }}>
      {fields.map((field: any, index: number) => {
        return (
          <div className={classes.fieldRow} key={`customer_${index}`}>
            <Field
              name={`${field}.first_name`}
              label="First name"
              validate={Fields.Validators.required}
              component={Fields.Text}
              className={classes.fieldCellLeft}
              width="224px"
            />
            <Field
              name={`${field}.last_name`}
              label="Surname"
              validate={Fields.Validators.required}
              component={Fields.Text}
              className={classes.fieldCellRight}
              width="224px"
            />
            {newCustomer && index === 1 && (
              <div className={classes.icon}>
                <Icons.DeleteIcon onClick={() => removeNewCustomer()} />
              </div>
            )}
          </div>
        );
      })}
      <div className={classes.fieldRowRev}>
        {fields.getAll().length === 1 && (
          <Button
            small
            onClick={addNewCustomer}
            color="primary"
            data-id="addClient"
          >
            Add New Client
          </Button>
        )}
      </div>
    </div>
  );
};

export default Customer;
